export const getApiBaseUrl = () => {
  let url = process.env.REACT_APP_IMG_URL || process.env.REACT_APP_API_URL || 'http://localhost:5000';
  url = url.replace(/\/api\/?$/, '').replace(/\/+$/, '');
  return url;
};

export const getImageUrl = (input, fallback = null) => {
  if (!input) return fallback;

  let val = input;
  for (let i = 0; i < 5; i++) {
    if (typeof val === 'string') {
      const trimmed = val.trim();
      if (
        (trimmed.startsWith('[') && trimmed.endsWith(']')) ||
        (trimmed.startsWith('{') && trimmed.endsWith('}')) ||
        (trimmed.startsWith('"') && trimmed.endsWith('"'))
      ) {
        try {
          const parsed = JSON.parse(trimmed);
          if (parsed !== val) {
            val = parsed;
            continue;
          }
        } catch (e) { }
      }
      break;
    } else if (Array.isArray(val)) {
      val = val.length > 0 ? val[0] : null;
    } else if (val && typeof val === 'object') {
      val = Object.values(val)[0] || null;
    } else {
      break;
    }
  }

  if (!val || typeof val !== 'string') return fallback;
  let url = val.trim().replace(/^["'[\]\s]+/, '').replace(/["'[\]\s]+$/, '');
  if (!url) return fallback;

  // Fix single slash typos like https:/ or http:/
  if (/^https?:\/[^/]/i.test(url)) {
    url = url.replace(/^(https?):\/+/, '$1://');
  }

  // Blob or Data URLs
  if (url.startsWith('blob:') || url.startsWith('data:')) {
    return url;
  }

  // Frontend assets
  if (url.startsWith('/assets/') || url.startsWith('assets/')) {
    return `/${url.replace(/^\//, '')}`;
  }

  const API_BASE = getApiBaseUrl();

  // If contains /uploads/
  if (url.includes('/uploads/')) {
    const afterUploads = url.split('/uploads/').pop();
    const clean = afterUploads.replace(/^\/+/, '');
    return `${API_BASE}/uploads/${clean}`;
  }

  // If starts with uploads/
  if (/^\/?uploads\//i.test(url)) {
    const clean = url.replace(/^\/?uploads\//i, '');
    return `${API_BASE}/uploads/${clean}`;
  }

  // External full URL
  if (url.startsWith('http://') || url.startsWith('https://')) {
    return url;
  }

  const clean = url.replace(/^\/+/, '');
  return `${API_BASE}/uploads/${clean}`;
};

export const toRelativePath = (url) => {
  if (!url || typeof url !== 'string' || url.startsWith('blob:') || url.startsWith('data:')) return null;
  const trimmed = url.trim();
  if (trimmed.includes('/uploads/')) {
    const afterUploads = trimmed.split('/uploads/').pop();
    return `uploads/${afterUploads.replace(/^\/+/, '')}`;
  }
  if (/^uploads\//i.test(trimmed)) {
    return trimmed.replace(/^\/+/, '');
  }
  if (trimmed.startsWith('http://') || trimmed.startsWith('https://')) {
    try {
      const pathname = new URL(trimmed).pathname;
      if (pathname.includes('/uploads/')) {
        const afterUploads = pathname.split('/uploads/').pop();
        return `uploads/${afterUploads.replace(/^\/+/, '')}`;
      }
      return pathname.replace(/^\//, '');
    } catch { /* fall through */ }
  }
  return trimmed.replace(/^\//, '');
};
